"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
// styles
//
const StyledSpinner_1 = require("./StyledSpinner");
const LoadingSpinner = () => {
    return (react_1.default.createElement(StyledSpinner_1.StyledSpinner, { className: 'spinner-border', role: 'status' },
        react_1.default.createElement("span", { className: 'sr-only' }, "Loading...")));
};
exports.default = LoadingSpinner;
